(() => {
  'use strict';
  if (window.UnchemedClassicOffer) return;
  const initialized = new WeakSet();
  let busy = false;
  const money = cents => '$' + (Number(cents) / 100).toLocaleString('en-US', {minimumFractionDigits: Number(cents) % 100 ? 2 : 0, maximumFractionDigits: 2});
  const fill = (value, params) => String(value || '').replace(/__([A-Z]+)__/g, (_, key) => params[key.toLowerCase()] ?? '');
  function init(scope = document) {
    scope.querySelectorAll('[data-classic-offer]').forEach(root => {
      if (initialized.has(root)) return;
      const form = root.querySelector('form'), button = root.querySelector('[data-classic-purchase]');
      let product;
      try {
        product = JSON.parse(document.getElementById('unc-classic-catalog').textContent);
        Object.assign(product.copy, JSON.parse(product.copy.dynamicJSON), JSON.parse(product.copy.detailsJSON));
      } catch (_) { return; }
      const ids = product.ids, keys = ['starter', 'annual', 'double'];
      if (!product.valid || String(product.id) !== '10117770084599' || !keys.every(k => product.variants.some(v => String(v.id) === ids[k]))) return;
      initialized.add(root);
      const copy = product.copy, get = selector => root.querySelector(selector);
      const text = (selector, value) => { const node = get(selector); if (node) node.textContent = value; };
      const hide = (selector, value) => { const node = get(selector); if (node) node.hidden = value; };
      const v3 = root.hasAttribute('data-v3');
      const variant = key => product.variants.find(v => String(v.id) === ids[key]);
      const params = new URLSearchParams(location.search);
      let selected = window.UnchemedClassicContext?.resolve(location.search) || (keys.includes(params.get('classic_offer')) ? params.get('classic_offer') : keys.find(k => ids[k] === (params.get('classic_variant') || params.get('variant'))) || 'annual');
      function render() {
        window.UnchemedClassicContext?.setSelected(selected);
        const item = variant(selected), starter = variant('starter'), annual = variant('annual'), double = variant('double');
        root.dataset.offer = selected; root.dataset.productId = String(product.id); root.dataset.variantId = String(item.id); root.dataset.value = String(item.price / 100); root.dataset.quantity = '1';
        form.elements.id.value = String(item.id); form.elements.quantity.value = '1';
        form.querySelectorAll('input[type=radio]').forEach(input => {
          input.checked = input.value === selected; input.disabled = busy;
          input.closest('.cx-option,.v3-opt').classList.toggle('is-selected', input.checked);
        });
        keys.forEach(key => text('[data-card-price="' + key + '"]', money(variant(key).price)));
        text('[data-detail="starter"]', copy.starter_detail);
        text('[data-detail="annual"]', fill(copy.annual_detail, {amount: money(annual.price - starter.price)}));
        text('[data-detail="double"]', fill(copy.double_detail, {unit: money(double.price / 2), total: money(double.price)}));
        text('[data-total]', money(item.price));
        const savings = selected === 'annual' ? copy.annual_save : selected === 'double' && starter.price * 2 > double.price ? fill(copy.double_save, {amount: money(starter.price * 2 - double.price)}) : '';
        text('[data-savings]', savings); hide('[data-savings]', !savings);
        text('[data-first-label]', copy[selected === 'double' ? 'double_label' : 'single_label']);
        hide('[data-refills-label]', selected !== 'annual');
        text('[data-includes-title]', copy[selected + '_title']); text('[data-includes]', copy[selected + '_contents']);
        hide('[data-duration]', selected !== 'annual');
        if (v3) root.querySelectorAll('[data-v3-under]').forEach(node => { node.hidden = node.dataset.v3Under !== selected; });
        const container = root.closest('[data-classic-home-offer],[data-classic-product]') || root;
        container.querySelectorAll('[data-classic-text]').forEach(node => { node.textContent = copy[node.dataset.classicText] || ''; });
        root.querySelector('.cx-panel,.v3-panel')?.setAttribute('aria-label', copy.region);
        text('[data-duration]', copy.duration);
        container.querySelectorAll('[data-classic-visual]').forEach(visual => {
          visual.dataset.package = selected;
          visual.setAttribute('aria-label', copy[selected === 'annual' ? 'annual_image' : selected === 'double' ? 'double_image' : 'single_image']);
          visual.querySelector('[data-classic-second-kit]').hidden = selected !== 'double';
          visual.querySelector('[data-classic-refills]').hidden = selected !== 'annual';
          visual.querySelectorAll('img').forEach(img => { if (!img.closest('[hidden]')) img.loading = 'eager'; });
        });
        const connected = Boolean(window.UnchemedCommerce?.openOfferCheckout);
        button.disabled = busy || !item.available || product.currency !== 'USD' || !connected;
        button.setAttribute('aria-busy', String(busy));
        button.textContent = busy ? copy.opening : fill(copy[item.available ? 'add' : 'sold_out'], {price: money(item.price)});
        text('[data-status]', product.currency !== 'USD' ? copy.currency : !item.available ? copy.unavailable : '');
      }
      form.addEventListener('change', event => {
        if (!event.target.matches('input[type=radio]') || busy || !keys.includes(event.target.value)) return;
        selected = event.target.value; get('.unc-checkout-error').hidden = true; render();
        root.dispatchEvent(new CustomEvent('unc:classic-offer-change', {bubbles:true, detail:{offer:selected}}));
      });
      const submit = event => {
        event.preventDefault();
        if (busy || button.disabled || !variant(selected).available) return;
        window.UnchemedCommerce.openOfferCheckout(form, product, ids[selected]);
      };
      form.addEventListener('submit', submit); button.addEventListener('click', submit);
      document.addEventListener('unc:commerce-state', event => { busy = Boolean(event.detail.busy); render(); });
      window.addEventListener('pageshow', () => { busy = false; render(); });
      render();
    });
  }
  window.UnchemedClassicOffer = Object.freeze({init, version: '2026-10-08.v3'});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

